import React from "react";
import { StrongText } from "../common";

export default function FounderCredentialsSection({ credentials, profile }) {
  return (
    <section className="founder-credentials">
      <div className="container founder-container">
        {credentials.map((item) => (
          <article className="founder-credentials-item" key={item.title}>
            <h2 className="heading text-capitalize">{item.title}</h2>
            {item.paragraphs.map((paragraph) => (
              <p key={paragraph}>
                <StrongText>{paragraph}</StrongText>
              </p>
            ))}
          </article>
        ))}
        <div className="founder-profile">
          <img src={profile.image} alt={profile.name} />
          <div>
            <h3>{profile.name}</h3>
            <p>{profile.role}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
